import React, { useEffect } from 'react';
import { useModal, ButtonColor } from '@ampol/design-system';

interface AcknowledgeModalProps {
  title: string;
  content: string;
  onClose?: () => void;
}

/**
 * Simple acknowledgement modal with a single OK button.
 * Opens automatically on mount and calls onClose when dismissed.
 */
const AcknowledgeModal = ({ title, content, onClose }: AcknowledgeModalProps) => {
  const modal = useModal({
    id: 'acknowledge-modal',
    title,
    content: <p>{content}</p>,
    color: ButtonColor.Blue,
    hideCloseButton: true,
    actions: [
      {
        label: 'OK',
        onClick: () => {
          modal.close();
          onClose?.();
        },
      },
    ],
  });

  useEffect(() => {
    modal.open();
  }, []);

  return null;
};

export default AcknowledgeModal;
